import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'

import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  width: 100%;
`

const StyledLink = styled(TextLink)`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-break: strict;
`

type SummaryDataItemProps = {
  title?: string
  value?: string | React.ReactElement
  url?: string
}
function SummaryDataItem(props: SummaryDataItemProps) {
  if (!props.title || !props.value) return null
  return (
    <Item>
      <BodyText weight="bold" variant="medium">
        {props.title}
      </BodyText>
      {props.url && (
        <StyledLink href={props.url} target="_blank" rel="nofollow">
          {props.value}
        </StyledLink>
      )}
      {!props.url && <BodyText variant="large">{props.value}</BodyText>}
    </Item>
  )
}
export default SummaryDataItem
